<ng-container *ngFor="let die of group; let i = index">
    <span style="display: contents;" [ngStyle]="{'color': getColor(ops[i-1])}">
        <span class="roll-part" *ngIf="i!=0">
            {{ops[i-1].replace('-','–')}}
        </span>
    </span>
    <ng-container *ngIf="die.type=='expressionroll'">
        <app-dicegroup [group]="die.dice" [ops]="die.ops"></app-dicegroup>
    </ng-container>
    <ng-container *ngIf="die.type=='die'">
        <app-dice [rolls]="die.rolls" [color]="getColor(ops[i-1])"></app-dice>
    </ng-container>
    <ng-container *ngIf="die.type=='number'">
        <span class="roll-part" [ngStyle]="{'color': getColor(ops[i-1])}">
            {{die.value}}
        </span>
    </ng-container>
</ng-container>